export default __webpack_public_path__ + "static/image2-b7a5883c861131827ac4eefe5db3b6b1.jpg";